import React from 'react';
import { CalendarView, Event } from '../../../types/calendar';
import MonthView from './views/MonthView';
import WeekView from './views/WeekView';
import DayView from './views/DayView';

interface CalendarGridProps {
  currentDate: Date;
  view: CalendarView;
  events: Event[];
  onSlotClick: (date: Date) => void;
  onEventClick: (event: Event, e: React.MouseEvent) => void;
}

export default function CalendarGrid({
  currentDate,
  view,
  events,
  onSlotClick,
  onEventClick
}: CalendarGridProps) {
  const renderView = () => {
    switch (view) {
      case 'month':
        return (
          <MonthView
            currentDate={currentDate}
            events={events}
            onSlotClick={onSlotClick}
            onEventClick={onEventClick}
          />
        );
      case 'week':
        return (
          <WeekView
            currentDate={currentDate}
            events={events}
            onSlotClick={onSlotClick}
            onEventClick={onEventClick}
          />
        );
      case 'day':
        return (
          <DayView
            currentDate={currentDate}
            events={events}
            onSlotClick={onSlotClick}
            onEventClick={onEventClick}
          />
        );
    }
  };

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      {renderView()}
    </div>
  );
}